<template>
  <el-col :span="24" class="zfMsg-update-wrap">
    <div class="zfMsg-update-item">
      <div class="userinfo-input">
        <div class="input-label">
          <p>选择日期</p>
          <span>(提前一个月登记)</span>
        </div>
        <el-tag type="info" disable-transitions effect="plain" round
          >{{
            showZfView == 4
              ? showZfLists[showZfOrderIdKey].news_date
              : FormData.wish_date
          }}
        </el-tag>
      </div>
    </div>
    <div class="zfMsg-update-item">
      <div class="userinfo-input">
        <div class="input-label">
          <p>选择祝福语类型</p>
        </div>
        <el-tag type="danger" disable-transitions effect="dark" round
          >{{
            showZfView == 4
              ? showZfLists[showZfOrderIdKey].wish_type
              : FormData.wish_type
          }}
        </el-tag>
      </div>
    </div>
    <div class="zfMsg-update-item">
      <div class="userinfo-input" style="width: 100%; overflow: hidden">
        <div class="input-label" style="justify-content: flex-start">
          <p>填写祝福语</p>
        </div>
        <p class="showZfmsg">
          {{
            showZfView == 4
              ? showZfLists[showZfOrderIdKey].content
              : FormData.content
          }}
        </p>
      </div>
    </div>
    <el-text tag="p" class="zfMsg-tishi"
      >本人确认刊登内容无误，并全权委托新民晚报予以刊登，文责自负。</el-text
    >
    <div class="zfMsg-update-item">
      <div class="userinfo-input" style="width: 100%; overflow: hidden">
        <p class="showRealname">
          {{
            showZfView == 4
              ? showZfLists[showZfOrderIdKey].realname
              : FormData.realname
          }}
        </p>
        <p class="showPhone">
          {{
            showZfView == 4
              ? showZfLists[showZfOrderIdKey].phone
              : FormData.phone
          }}
        </p>
      </div>
    </div>
    <div class="zfMsg-orderId-wrap" v-if="showZfView == 4">
      <p>订单编号</p>
      <p>{{ showZfLists[showZfOrderIdKey].number }}</p>
    </div>
    <div class="zfMsg-btn" v-else>
      <el-button
        type="danger"
        :disabled="canConfirm"
        @click="zfConfirm"
        class="userInfoSubmit"
        >确认
      </el-button>
      <el-button color="#535e9f" dark @click="submitBack" class="userInfoSubmit"
        >修改
      </el-button>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "ZfUpdate",
  props: {
    zfMsgForm: Object,
    canConfirm: Boolean,
    zfConfirm: Function,
    submitBack: Function,
    zfLists: Array,
    zfView: Number,
    showZfOrderIdKey: Number,
  },
  data() {
    return {
      showZfView: this.zfView,
      FormData: this.zfMsgForm,
      showZfLists: this.zfLists,
    };
  },
};
</script>

<style scoped>
.zfMsg-update-wrap {
  margin: auto;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.userinfo-input {
  border: 0;
  margin-bottom: 10px;
}

.zfMsg-update-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
  line-height: 32px;
  position: relative;
  min-width: 0;
  text-align: left;
}

.showZfmsg,
.showRealname,
.showPhone {
  --el-tag-bg-color: var(--el-fill-color-blank);
  --el-tag-border-color: var(--el-color-info-light-5);
  --el-tag-hover-color: var(--el-color-info);
  --el-tag-text-color: var(--el-color-info);
  background-color: var(--el-tag-bg-color);
  border-color: var(--el-tag-border-color);
  color: var(--el-tag-text-color);
  display: block;
  vertical-align: middle;
  font-size: 16px;
  border-width: 1px;
  border-style: solid;
  line-height: 1.5;
  padding: 10px;
  border-radius: 20px;
}

.showRealname {
  margin-bottom: 10px;
}

.zfMsg-tishi {
  text-align: justify;
  color: var(--zfSend-input-text);
  margin: 10px 0;
}

.zfMsg-btn,
.zfMsg-orderId-wrap {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}

.zfMsg-btn button {
  width: 50%;
}

.zfMsg-orderId-wrap p {
  font-size: 16px;
}

.zfMsg-orderId-wrap p:last-child {
  padding-left: 10px;
}
</style>